export default "__VITE_PUBLIC_ASSET__1a2e733f__"